import { lazy } from 'react';
import type { AppManifest } from '@/apps/types';

/**
 * Outlook Express 6 — the site owner's contact form in costume.
 *
 * There is no mail server anywhere behind this. The Inbox is three messages
 * compiled into the bundle, and **Send** hands a `mailto:` to whatever mail
 * program the visitor's real computer has registered. That is the entire
 * back end.
 *
 * A singleton, because XP's Start menu gave e-mail exactly one pinned slot and
 * two Outlook Express windows was never a thing anyone wanted.
 *
 * Args (all optional — re-opening the singleton with new ones re-arms it):
 *   compose  truthy   open straight into the New Message view
 *   subject  string   pre-fills the subject line
 *   body     string   pre-fills the message body
 */
export const outlookApp: AppManifest = {
  id: 'outlook',
  name: 'Outlook Express',
  icon: '/assets/icons/outlook.svg',
  component: lazy(() => import('./Outlook')),

  defaultSize: { w: 720, h: 520 },
  minSize: { w: 480, h: 360 },
  resizable: true,
  maximizable: true,
  singleton: true,

  // XP pinned exactly two things above the separator: a browser and a mail
  // client. This is the mail client.
  pinned: true,
  group: 'Internet',

  // The component re-titles itself per folder once it has mounted; this is what
  // the title bar and the taskbar button show in the meantime.
  titleFor: (args) => (args.compose ? 'New Message' : 'Inbox - Outlook Express'),
};
